module.exports = __webpack_public_path__ + "static/media/premierOneRightSeatMobileTaken.c37eeea0.svg";